import axios from "../axios";

export async function fetchCommuncations(payload) {
  const customer = payload?.customer_id;
  return axios({
    method: "get",
    url: "/customers/" + customer + "/communications",
    params: payload,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchCommuncation(payload) {
  const customer = payload?.customer_id;
  return axios.get(`/customers/${customer}/communications/${payload.id}`);
}

export async function fetchCommuncationPdf(payload) {
  const customer = payload?.customer_id;
  const response = await axios.get(
    `/customers/${customer}/communications/${payload.id}/pdf`,
    { responseType: "blob" }
  );
  if (response.status >= 400) {
    let data = response.data;
    if (data instanceof Blob) {
      try {
        data = JSON.parse(await data.text());
      } catch {
        data = { message: response.statusText };
      }
    }
    return Promise.reject(data ?? { message: response.statusText });
  }
  const blob = new Blob([response.data], { type: "application/pdf" });
  return { pdf_url: URL.createObjectURL(blob) };
}
